import { Dropdown } from 'bootstrap';
import $ from 'jquery';
import 'slick-carousel';

$(() => {
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((el) => {
    // eslint-disable-next-line no-new
    new Dropdown(el);
  });

  const $form = $('#contactForm');
  if ($form.length) {
    $form.on('submit', (e: JQuery.SubmitEvent) => {
      e.preventDefault();
      $.ajax({
        url: $form.attr('action') || window.location.href,
        method: 'POST',
        data: $form.serialize(),
        success: () => {
          $form.closest('.container').addClass('d-none');
          $('#contactFormSuccess').removeClass('d-none');
        },
        error: () => {
          $form.closest('.container').addClass('d-none');
          $('#contactFormSuccess').removeClass('d-none');
        },
      });
    });
  }

  $('.headerSlider').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    arrows: true,
    prevArrow: "<button type='button' class='slick-arrow slick-prev pull-left'>"
      + "<i class='far fa-chevron-left'></i></button>",
    nextArrow: "<button type='button' class='slick-arrow slick-next pull-right'>"
      + "<i class='far fa-chevron-right'></i></button>",
  });

  $('.paginaSlider').slick({
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    arrows: true,
    prevArrow: "<button type='button' class='slick-arrow slick-prev pull-left'>"
      + "<i class='far fa-chevron-left'></i></button>",
    nextArrow: "<button type='button' class='slick-arrow slick-next pull-right'>"
      + "<i class='far fa-chevron-right'></i></button>",
  });
});
